<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/159ZpPm/tc-custom/9781609250539.jpg?1721429611315" alt="This image is the cover for the book Book of the Bizarre"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Book of the Bizarre
      </h1>
      <p class="bookDescription body article font2">
        <b>From enchanted animals to bizarre rock-and-roll stories, discover hundreds of far-out facts guaranteed to give your trivia game a whole new twist.</b><br/><br/>Did you know duck dander is hallucinogenic? Or that Katherine Hepburn had a phobia of dirty hair? Have you ever wondered about the Magical Skull of Doom or contemplated the mysterious Transylvanian Tablets? <i>The Book of the Bizarre</i> is a veritable treasure trove of startling and stranger-than-fiction trivia that spans history, continents, even worlds. Never before have so many truly frightful facts been gathered together in one place. Teeming with the strange, the shocking, and the downright fantastic, <i>The Book of the Bizarre</i>’s thirteen chapters include: Something Wicked: Mysterious Objects &amp; Haunted Homes, Tender Murderers and Malevolent Males: Killingly Good Tales of Terror, and Morbid Writers and Tortured Artists: From Edgar Allan Poe to Vincent Van Gogh. Terrifying topics range from Corpses on Campus to Strange Rock and Roll Stories to Medical Maladies, Conspiracy Theories, Superstitions, Hexes, and even UFOs. <i>The Book of the Bizarre</i> is designed for the depraved, outlandish enough for the eccentric, and freaky enough for even the hardest trivia nut.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Varla Ventura
      </h2>
      
      <p class="authorDescription body article">Varla Ventura is the author of Varla Ventura's Paranormal Parlor: Ghosts, Seances and Tales of True Hauntings, as well as Fairies, Pookas, and Changelings: A Complete Guide to the Wild & Wicked Enchanted Realm, along with several other books on spooky ooky stuff.  She can often be found lurking about the deep dark woods, lakes, streams and parlors on the hunt for beastly things and hidden history. Visit her online at www.varlaventura.net</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Weiser Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?265b73ba